// src/assets/components/Loading.jsx
import React from 'react';
import '../styles/Loading.css';

const Loading = () => {
    return (
        <div className="loading-screen" role="alert" aria-busy="true">
            <div className="spinner"></div>
            <p>Carregando, por favor aguarde...</p>
        </div>
    );
};

export default Loading;
